import React from 'react';

const CorrectAnswerCard = ({
  cricketerName = '',
  cricketerRole,
  xAxis = 'X',
  yAxis = 'Y',
  xValue,
  yValue,
}) => {
  return (
    <div style={{
      width: '100%',
      background: 'var(--c-cream)',
      border: 'var(--border-ink)',
      borderRadius: 'var(--radius-btn)',
      boxShadow: 'var(--shadow-hard)',
      padding: '10px 12px',
      display: 'flex', alignItems: 'center', gap: 10,
      animation: 'penFadeSlideIn 420ms var(--ease-pop) both',
    }}>
      <div style={{
        flexShrink: 0,
        fontFamily: 'var(--font-mono)', fontSize: 9, fontWeight: 700, letterSpacing: 0.6,
        color: 'var(--c-cream)', background: 'var(--c-ink)',
        padding: '4px 7px', borderRadius: 6,
        alignSelf: 'flex-start',
      }}>ANSWER</div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontFamily: 'var(--font-display)', fontSize: 16, lineHeight: 1.05,
          color: 'var(--c-ink)', letterSpacing: 0.3,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>{(cricketerName || '—').toString().toUpperCase()}</div>
        {cricketerRole && (
          <div style={{
            fontFamily: 'var(--font-mono)', fontSize: 9, fontWeight: 700,
            color: 'var(--c-ink)', opacity: 0.7, letterSpacing: 0.5,
            marginTop: 2,
          }}>{cricketerRole.toString().toUpperCase()}</div>
        )}
      </div>

      <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
        <div style={{
          fontFamily: 'var(--font-mono)', fontWeight: 700, fontSize: 11,
          padding: '4px 8px', borderRadius: 6,
          background: 'var(--c-blue)', color: 'var(--c-cream)',
          border: '1.5px solid var(--c-ink)',
          boxShadow: 'var(--shadow-hard-sm)',
          lineHeight: 1.1,
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 8, opacity: 0.85, letterSpacing: 0.4 }}>{xAxis.toString().toUpperCase()}</div>
          <div style={{ fontSize: 12 }}>{xValue ?? '—'}</div>
        </div>
        <div style={{
          fontFamily: 'var(--font-mono)', fontWeight: 700, fontSize: 11,
          padding: '4px 8px', borderRadius: 6,
          background: 'var(--c-ink)', color: 'var(--c-cream)',
          border: '1.5px solid var(--c-ink)',
          boxShadow: 'var(--shadow-hard-sm)',
          lineHeight: 1.1,
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 8, opacity: 0.85, letterSpacing: 0.4 }}>{yAxis.toString().toUpperCase()}</div>
          <div style={{ fontSize: 12 }}>{yValue ?? '—'}</div>
        </div>
      </div>
    </div>
  );
};

export default CorrectAnswerCard;
